/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { user } from '../../api';
import SignupLayout from '../shared/SignupLayout';
import { nextPendingDestination } from './kycDestination';
import { peekKycReturnUrl, takeKycReturnUrl } from '../Oauth/kycReturn';

const KYCPending = () => {
  const { t: translate } = useTranslation();
  const history = useHistory();
  useQuery('user', user.details, {
    refetchInterval: 10000, // 10 seconds
    refetchIntervalInBackground: true,
    onSuccess: (data) => {
      const destination = nextPendingDestination(data.user.verification_state, peekKycReturnUrl());

      if (!destination) {
        return;
      }

      history.push(destination);
      takeKycReturnUrl();
    },
  });

  return (
    <SignupLayout>
      <div className="d-flex flex-row align-items-center justify-content-between">
        <strong
          className="flex-row-center"
          onClick={history.goBack}
          role="button"
          tabIndex="0"
          onKeyPress={history.goBack}>
          <span className="icon-arrow-back-navigation me-2 text-f4" />
          <span className="m-0">{translate('kyc_page_title')}</span>
        </strong>
        <p className="text-shadow text-f6">{translate('kyc_veriff_pending_page_title')}</p>
      </div>
      <div className="text-center mx-auto pt-5">
        <img className="success-icon" src="./assets/images/success.svg" alt="Success" />
        <p className="my-4">{translate('kyc_waiting_full_title')}</p>
        <p className="mx-auto">
          <strong>{translate('kyc_waiting_full_text')}</strong>
        </p>
        <p className="text-shadow text-f6 mt-4 mb-3">{translate('faq')}</p>
        <a href="/" className="link text-decoration-none">
          <strong>{translate('support')}</strong>
        </a>
      </div>
    </SignupLayout>
  );
};

export default KYCPending;
